export default __webpack_public_path__ + "static/media/history_img_4.87389f75.png";